import { render, staticRenderFns } from "./Cardschool.vue?vue&type=template&id=ff815e8e&scoped=true"
import script from "./Cardschool.vue?vue&type=script&lang=js"
export * from "./Cardschool.vue?vue&type=script&lang=js"
import style0 from "./Cardschool.vue?vue&type=style&index=0&id=ff815e8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff815e8e",
  null
  
)

export default component.exports